import useAxios from '@hooks/useFetch';
import { components, paths } from '@api/api';

export type ByoSettingOutput = components['schemas']['ByoSettingOutput'];

const BYO_SETTINGS_ENDPOINT: keyof paths = '/ByoSettings';

export interface UseByoSettingReturn {
    data: ByoSettingOutput | null;
    isLoading: boolean;
    error: string;
    doFetch: () => void;
}

export default function useByoSetting(id: number | null): UseByoSettingReturn {
    return useAxios<ByoSettingOutput>({
        method: 'get',
        url: `${BYO_SETTINGS_ENDPOINT}/${id}`,
        lazy: id === null,
    });
}
